export interface FarmingBundleEntry {
  action: string;        // Disposition type (e.g., "Ignore From Farming Dashboard")
  value: number | null;  // Numeric value
}

export interface FarmingOverrideEntry {
  campaign: string;
  target: string;
  overrideBid: number | null;
  overrideStatus: string;
  expirationDate: string;  // MM/DD/YYYY format
}

export interface FarmingReviewFormData {
  // Bundle disposition (required)
  bundleEntry: FarmingBundleEntry;
  // Override bid (optional)
  overrideEntry: FarmingOverrideEntry | null;
  // Settings (optional — only sent if changed)
  cstOverride: number | null;
  limitToMaxBid: boolean | null;
  newPpcStatus: string;
  pauseFarming: boolean | null;
  // Notes
  notes: string;
}

export interface FarmingReviewFormProps {
  onFormChange?: (data: FarmingReviewFormData) => void;
  initialData?: Partial<FarmingReviewFormData>;
}

export const createDefaultFarmingFormData = (): FarmingReviewFormData => ({
  bundleEntry: { action: '', value: null },
  overrideEntry: null,
  cstOverride: null,
  limitToMaxBid: null,
  newPpcStatus: '',
  pauseFarming: null,
  notes: '',
});
